import styled from "styled-components";
import { AnimatePresence, motion } from "framer-motion";
import { ReactNode, useEffect } from "react";

interface ModalProps {
  onClick?: () => void;
  onEntered?: () => void;
  closedHandler: () => void;
  children?: ReactNode; // children prop 추가
  isVisible?: boolean; // 모달 표시 여부
  size?: "s" | "m" | "l";
}

let activeModalCount = 0;
let originalBodyOverflow = "";

const ModalCenterLayout = (props: ModalProps) => {
  // 모달 표시 상태에 따라 스크롤 제한
  useEffect(() => {
    if (!props.isVisible) return;
    if (activeModalCount === 0) {
      originalBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    activeModalCount += 1;
    return () => {
      activeModalCount -= 1;
      if (activeModalCount === 0)
        document.body.style.overflow = originalBodyOverflow;
    };
  }, [props.isVisible]);

  const sizeClass =
    props.size === "s"
      ? "modal-s"
      : props.size === "m"
        ? "modal-m"
        : props.size === "l"
          ? "modal-l"
          : "";
  return (
    <AnimatePresence>
      {props.isVisible && ( // 조건부 렌더링 추가
        <ModalContainer
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.3,
            type: "fade",
          }}
        >
          <div className="overlay"></div>
          <ModalInner
            className={sizeClass}
            variants={{ closed: { y: "100%" }, open: { y: "0%" } }}
            initial="closed"
            animate="open"
            exit="closed"
            onAnimationComplete={definition => {
              if (definition === "open") props.onEntered?.();
            }}
            transition={{
              type: "spring",
              stiffness: 400,
              damping: 40,
            }}
          >
            {props.children}
          </ModalInner>
        </ModalContainer>
      )}
    </AnimatePresence>
  );
};

export default ModalCenterLayout;

const ModalContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  padding: 3rem;
  justify-content: center;
  align-items: center;
  cursor: "pointer";
  width: 100%;
  height: 100%;
  .overlay {
    display: flex;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
`;

const ModalInner = styled(motion.div)`
  background-color: white;
  width: 100%;
  border-radius: 1rem;
  overflow: hidden;
  &.modal-s {
    max-width: 40rem;
  }
  &.modal-m {
    max-width: 899px;
    min-height: 500px;
  }
  &.modal-l {
    max-width: 1080px;
  }
  @media screen and (min-width: 785px) {
    max-width: 54rem;
    left: auto;
  }
`;
